import React from 'react';
import PropTypes from 'prop-types';

import { SILVER_SAND } from '@constant/colors';

export default class ArrowCircle extends React.Component {
  static propTypes = {
    className: PropTypes.string,
    color: PropTypes.string,
    hoverColor: PropTypes.string,
    onClick: PropTypes.func,
    onMouseOut: PropTypes.func,
    onMouseOver: PropTypes.func,
  };

  static defaultProps = {
    color: SILVER_SAND,
  };

  state = {
    hover: false,
  };

  constructor(props) {
    super(props);

    this.onMouseOut = this.onMouseOut.bind(this);
    this.onMouseOver = this.onMouseOver.bind(this);
  }

  onMouseOut() {
    this.setState({ hover: false });
    if (this.props.onMouseOut) {
      this.props.onMouseOut();
    }
  }

  onMouseOver() {
    this.setState({ hover: true });
    if (this.props.onMouseOver) {
      this.props.onMouseOver();
    }
  }

  render() {
    const { className, color, hoverColor, onClick } = this.props;

    const fillColor = this.state.hover && hoverColor ? hoverColor : color;

    return (
      <svg
        viewBox="0 0 24 24"
        className={className}
        onMouseOut={this.onMouseOut}
        onMouseOver={this.onMouseOver}
        onClick={onClick}
      >
        <path
          d="M22 12c0-5.523-4.477-10-10-10S2 6.477 2 12s4.477 10 10 10 10-4.477 10-10zM0 12C0 5.373 5.373 0 12 0s12 5.373 12 12-5.373 12-12 12S0 18.627 0 12zm10.576 0l3.23 3.23c.447.448.452 1.17.002 1.62-.446.445-1.17.444-1.618-.004L8.154 12.81c-.225-.225-.337-.517-.338-.81 0-.292.11-.584.335-.808l4.04-4.038c.447-.448 1.17-.452 1.618-.003.446.448.446 1.172-.002 1.62L10.576 12z"
          fill={fillColor}
          fillRule="evenodd"
        />
      </svg>
    );
  }
}
